import React, { Fragment, useEffect, useState } from "react";
import moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import * as action from "../actions";
import lodash from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import Profile from "../assets/SVG/icons/Avatar.svg";
import Alerts from "../assets/SVG/icons/alerts.svg";
import BackIcon from "../assets/SVG/buttons/back-button.svg";
import axios from "axios";
import config from "../config";
import "../styles/alertspage.css";
import { getAlerts, getUserDetail } from "../api";
import { fetchMoreAlerts } from "../utils/common";
axios.defaults.withCredentials = true;

export default function AlertsPage(props) {
  const dispatch = useDispatch();
  
  const user = useSelector((state) => state.user);
  const [isLoading, setLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [isEmptyAlert, setIsEmptyAlert] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);

  useEffect(() => {
    document.title = "Alerts";
    getAlerts(size, page, user?.uid).then((res) => {
      setTotalAlerts(res.total);
      setAlerts(res.alerts);
      if (res.alerts.length === 0) {
        setIsEmptyAlert(true);
      }
      setLoading(false);
    });
  }, []);
  

  const makeAlertReadById = async (alertId) => {
    // update the alert to read.
    const alertResp = await axios.post(config.backend_url + `/alert/read`, {
      alertId,
    });

    // Update the alerts status locally on this state.
    if (alertResp?.data?.success) {
      const updatedAlerts = alerts.map((alert) => {
        if (alert._id === alertId) {
          alert.status = "read";
        }
        return alert;
      });
      setAlerts(updatedAlerts);
    }

    // Update on user object with latest alerts
    const updatedUser = await getUserDetail();
    dispatch(action.updateUser(updatedUser.userInfo));
  };

  const _sortedAlerts = lodash.cloneDeep(alerts).sort((a, b) => moment(b.createdAt) - moment(a.createdAt));

  // filter last 90 days alert only.
  const latestDays = moment().subtract(90, 'days');
  const sortedAlerts = _sortedAlerts.filter( alert => {
      return moment(alert.createdAt).format() > latestDays.format()
  })
  return (
    <div className="container">
      {isLoading ? <div id="homepage-loading" data-testid="homepage-loading"></div> : <></>}
      <div className="main navigation" data-testid="alerts-page">
        <div className="header mt-3">
          <img src={BackIcon} alt="go-back" data-testid="go-back" onClick={() => props.history.goBack()}></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            data-testid="go-navigation"
            className="profile mt-4"
            onClick={() => props.history.push("/navigation")}
          ></img>
          <img src={Home} alt="home" data-testid="go-home" onClick={() => props.history.push("/home")}></img>
        </div>
        <div className="text-center mt-3 alerts-heading">
          <img src={Alerts} alt="alerts"></img>
          <span>Alerts</span>
        </div>
        <div id="alerts" className="alert mt-5" data-testid="alerts-scroll">
          {isEmptyAlert ||  lodash.isEmpty(sortedAlerts) ? (
            <p>No alerts to show</p>
          ) : (
            <InfiniteScroll
              dataLength={sortedAlerts.length}
              next={() => fetchMoreAlerts({
                alerts,
                totalAlerts,
                size,
                page,
                user,
                getAlerts,
                setHasMore,
                setAlerts,
                setPage
              })}
              hasMore={hasMore}
              loader={<p>Loading...</p>}
              // height={400}
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>End of the Alerts</b>
                </p>
              }
            >
              {sortedAlerts.map((alert) => {
                return (
                  <div
                    className="alert-card"
                    data-testid="alert-card"
                    key={alert._id}
                    onClick={() => props.history.push(`/alerts/${alert._id}`)}
                  >
                    <div className="alert-card-head">
                      <div className="card-date">
                        <div className={`grey-circle ${alert.status}`}></div> 
                        <div className="card-date-timestamp">
                          <div className="alert-card-month-day">{moment(alert.createdAt).tz(user.timezone || config.defaultTimezone).format("MMM DD")}</div>
                          <div className="alert-card-time">{moment(alert.createdAt).tz(user.timezone || config.defaultTimezone).format("LT")}</div>
                        </div>
                      </div>
                    </div>
                    <div className="alert-card-body" data-testid="alert-card-body" onClick={() => makeAlertReadById(alert._id)}>
                      <div className="alert-card-body-title">{alert?.title}</div>
                      <div className="alert-card-body-short-message">{alert?.shortMessage}</div>
                    </div>
                  </div>
                );
              })}
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  );
}
